module.exports = __webpack_public_path__ + "static/media/21ECLAC45.6b8d393e.jpg";